export const EXPENSE_CATEGORIES = [
    {
        "expense_category": "Personal",
        "expense_subcategory": null
    },
    {
        "expense_category": "Transporte",
        "expense_subcategory": "Peajes"
    },
    {
        "expense_category": "Transporte",
        "expense_subcategory": "Avion"
    },
    {
        "expense_category": "Transporte",
        "expense_subcategory": "Parking"
    },
    {
        "expense_category": "Transporte",
        "expense_subcategory": "Taxi"
    },
    {
        "expense_category": "Alojamiento",
        "expense_subcategory": null
    },
    {
        "expense_category": "Alojamiento",
        "expense_subcategory": "Airbnb"
    },
    {
        "expense_category": "Alojamiento",
        "expense_subcategory": "Hotel"
    },
    {
        "expense_category": "Alojamiento",
        "expense_subcategory": "Otro"
    },
    {
        "expense_category": "Comidas",
        "expense_subcategory": null
    },
    {
        "expense_category": "Transporte",
        "expense_subcategory": "Alquiler"
    },
    {
        "expense_category": "Otros",
        "expense_subcategory": null
    },
    {
        "expense_category": "Comidas",
        "expense_subcategory": "Supermercado"
    },
    {
        "expense_category": "Transporte",
        "expense_subcategory": null
    },
    {
        "expense_category": "Transporte",
        "expense_subcategory": "Ave"
    },
    {
        "expense_category": "Transporte",
        "expense_subcategory": "Gasolina"
    },
    {
        "expense_category": "Transporte",
        "expense_subcategory": "Furgo"
    },
    {
        "expense_category": "Comidas",
        "expense_subcategory": "Restaurante"
    },
    {
        "expense_category": "Transporte",
        "expense_subcategory": "Bus"
    }
];

export const PAYMENT_MILESTONES = [
    { percentage: 0.20, label: "Reserva (20%)", due_desc: "A la firma" },
    { percentage: 0.80, label: "Restante (80%)", due_desc: "1 semana antes" }
];
